export default __webpack_public_path__ + "static/media/attachment-line.5de75034.svg";